export default __webpack_public_path__ + "static/media/notification.6fe86f2d.svg";